import { render, staticRenderFns } from "./aRmsYearSalesTable.vue?vue&type=template&id=75fac9d2&scoped=true"
import script from "./aRmsYearSalesTable.vue?vue&type=script&lang=js"
export * from "./aRmsYearSalesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fac9d2",
  null
  
)

export default component.exports